import React, { useEffect } from 'react'
import { Downgraded, useHookstate } from '@hookstate/core'
import { Grid, Typography } from '@mui/material'
import ColumnChart from '~/components/ColumnChart'
import { useLang } from '~/hooks/useLang'
import { getDispatchByDevice } from './services/index'
import { IDespacthStatisticGraphProps } from '../../interfaces/IDispacthStatistic'
import ColumnChartVertical from '~/components/ColumnChartMui/VerticalChart'
import { useMarkerState } from '~/features/Map/stores/MapState'

type PayloadProps = {
  readonly withSolvedThirdParty?: boolean
  readonly exludeClosed?: boolean
}
type ResponseProps = ReadonlyArray<{
  readonly item: string
  readonly value: number
}>

export default function DispatchByDeviceCharts({
  agencyId,
  searched,
  deviceId,
  operationId,
  dispatchGroupId,
  category,
  type,
  subtype,
  dateStart,
  dateFinish,
  thirdParty,
  refresh,
  consummated,
  loading,
  statusIds,
  cityIds,
  groupSetId,
  location,
  operationUnitId,
  closedStatusClassId,
  closedStatusId,
  qualifierOptions,
  expandFilterSearch,
  phone,
  requester,
  userId,
  districtIds,
  geographicalArea,
  startTime,
  endTime,
}: IDespacthStatisticGraphProps) {
  const { translate } = useLang()
  const deviceData = useHookstate<ResponseProps>([])
  const payload = useHookstate<PayloadProps>({
    withSolvedThirdParty: thirdParty,
    exludeClosed: false,
  })
  const deviceDataTotal = useHookstate<number>(0)

  useEffect(() => {
    payload.set({ withSolvedThirdParty: thirdParty, exludeClosed: false })
    deviceDataTotal.set(0)
    loading.set(true)

    getDispatchByDevice(
      agencyId,
      deviceId,
      operationId,
      dispatchGroupId,
      category,
      type,
      subtype,
      dateStart,
      dateFinish,
      payload.get(),
      consummated,
      statusIds,
      cityIds,
      groupSetId,
      location,
      operationUnitId,
      closedStatusClassId,
      closedStatusId,
      qualifierOptions,
      phone,
      requester,
      userId,
      districtIds,
      geographicalArea,
      startTime,
      endTime,
    )
      .then((response) => {
        const result = response.map((responseData) => {
          deviceDataTotal.set(deviceDataTotal.get() + responseData.total)
          return { item: responseData.name, value: responseData.total }
        })
        return deviceData.set(result)
      })
      .finally(() => {
        loading.set(false)
      })
  }, [refresh])

  useEffect(() => {
    if (!searched) {
      deviceData.set([])
    }
  }, [searched])

  return (
    <Grid
      container
      xs={12}
      sx={{
        display: 'flex',
        paddingX: 3,
        paddingTop: 3,
        justifyContent: 'space-between',
      }}
    >
      <Grid item xs={12} hidden={!expandFilterSearch} paddingBottom={1}>
        <Typography sx={{ fontWeight: 'bold', fontSize: 16 }}>
          {translate('Dispatch by Device')}
        </Typography>
      </Grid>
      <Grid item xs={12} hidden={!expandFilterSearch}>
        <ColumnChartVertical
          data={deviceData.attach(Downgraded).get()}
          title={'Dispatch x Device'}
          subtitle={`Total: ${deviceDataTotal.get()}`}
          typeTotal="Devices"
        />
      </Grid>
    </Grid>
  )
}
